<template>
    <div>
        <TopBackground :titles="'欢迎您使用卓然CLC认证防伪系统'" :smalls="smalls"/>
        <!-- form -->
        <div class="clcForm"  v-loading="loading">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item  prop="code">
                    <el-input v-model="form.code" placeholder="输入防伪标识码"></el-input>
                </el-form-item>
                <el-form-item  prop="checkCode">
                    <el-input v-model="form.checkCode" placeholder="输入验证码" style="width:395px;margin-right:5px;float:left"></el-input>
                    <!-- 验证码组件 -->
                    <div class="login-code" @click="refreshCode">
                        <s-identify :identifyCode="identifyCode" :contentWidth="100"></s-identify>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" round style="width:100%" @click="handleCert">验证</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import SIdentify from '@/components/SIdentify'
import request  from "@/util/request";
export default {
    components:{
        SIdentify
    },
    data() {
        const validateCode = (rule, value, callback) => {
            if (this.identifyCode !== value) {
                this.refreshCode()
                callback(new Error('验证码错误'))
            } else {
                callback()
            }
        }
        return {
            loading:false,
            smalls: ['这里，您可以下载有关数字化产品的使用手册或其他相关文档。'],
            form: {},
            rules: {
                code: [
                    { required: true, message: '请输入防伪标识码', trigger: 'blur' },
                    { pattern:/^\S{7,}$/, message: "请输入7位以上标识码，", trigger: "blur"}
                ],
                checkCode:[
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ]
            },
            // 验证码
            identifyCode: ""
        }
    },
    mounted(){
        // 验证码
        this.refreshCode();
    },
    methods:{
        //验证码
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            // 获取随机数
            let codes = '0123456789';
            for (let i = 0; i < 4; i++) {
                this.identifyCode += codes[this.randomNum(0, codes.length)];
            }
        },
        // 验证
        handleCert() {
            this.$refs.form.validate(valid => {
              this.refreshCode();
                if (!valid) return false;
                this.loading = true;
                request.get('/auth/check?code='+this.form.code).then(res=>{
                  console.log(res)
                  this.loading=false
                  if(res.status===200&&(res.data.code_state==="" ||res.data.code_state==='0' )){
                    this.$confirm('验证成功，该产品有效', '提示', {
                      confirmButtonText: '确定',
                      type: 'success'
                    })
                    // this.$message.success("验证成功")
                  }else{
                    this.$confirm('验证失败，请确定防伪标识码是否正确', '提示', {
                      confirmButtonText: '确定',
                      type: 'error'
                    })
             }
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.clcForm{
    width: 500px;
    margin: 80px auto;
}
.login-code{
    height: 40px;
}
</style>
